import React, { useState } from 'react';

import { removeScheduleWeekend } from '../../../api';
import { ConfirmationDialog } from '../../../components/UIKit/ConfirmationDialog';
import { scheduleApi } from '../../../effector/schedule';
import { Weekend } from '../../../types/marketSchedule';

type Props = {
  weekend: Weekend;
  onClose: () => void;
};

export const ScheduleRemoveWeekendDialog: React.FC<Props> = ({ weekend, onClose }) => {
  const [send, setSend] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    if (!send) {
      setError('');
      onClose();
    }
  };

  const onConfirm = () => {
    setSend(true);
    setError('');

    removeScheduleWeekend(weekend)
      .then((response) => {
        if (response?.success) {
          scheduleApi.removeWeekend(weekend);
          onClose();
          return;
        }

        setError(response?.errorMessage ?? 'Ошибка на сервере');
        setSend(false);
      })
      .catch((e) => {
        setError(e.toString());
        setSend(false);
      });
  };

  return (
    <ConfirmationDialog
      title="Удаление неторгового дня"
      description={`Вы уверены, что хотите удалить расписание на дату ${weekend.day}?`}
      error={error}
      isLoading={send}
      onConfirm={onConfirm}
      onClose={handleClose}
    />
  );
};
